import { Flex, Text, VStack } from '@chakra-ui/react'
import { useState } from 'react'
import { BsPeopleFill } from 'react-icons/bs'
import SearchUsersPanel from '../components/adminUsers/SearchUsersPanel'
import TableAllUsers from '../components/adminUsers/TableAllUsers'
import { Block } from '../components/shared'
import searchQueryContext from '../context/searchQueryContext'

const AdminUsers = () => {
    const [query, setQuery] = useState(null)

    return (
        <Flex p="40px" direction="column" w="full">
            <Block title="รายการบัญชีผู้ใช้ทั้งหมด" icon={BsPeopleFill}>
                <VStack w="full" spacing={10}>
                    <searchQueryContext.Provider value={[query, setQuery]}>
                        <SearchUsersPanel />
                        <Text fontWeight="bold">ผลลัพธ์การค้นหา</Text>
                        <TableAllUsers />
                    </searchQueryContext.Provider>
                </VStack>
            </Block>
        </Flex>
    )
}

export default AdminUsers

